import React from "react";
import { hydrateRoot, createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { HelmetProvider } from "react-helmet-async";

import store from "./store";
import App from "./App";
import "./index.css";

const AppTree = (
  <HelmetProvider>
    <Provider store={store}>
      <App />
    </Provider>
  </HelmetProvider>
);

const rootElement = document.getElementById("root");

// Check if the server-rendered HTML matches the current route.
// Nginx might have served the index.html (home page) as a fallback for a detail page.
const meta = document.querySelector('meta[name="prerender-route"]');
const prerenderedRoute = meta ? meta.getAttribute('content') : null;
const currentPath = window.location.pathname;

// A loose match (e.g., both are '/' or the prerendered route matches exactly)
// We handle trailing slashes by removing them for comparison
const normalize = (p) => (p === '/' ? p : p.replace(/\/$/, ''));
const isRouteMatch = !prerenderedRoute || normalize(prerenderedRoute) === normalize(currentPath);

if (rootElement.hasChildNodes() && isRouteMatch) {
  // Safe to hydrate: the HTML matches the route
  hydrateRoot(rootElement, AppTree);
} else {
  // Hydration mismatch risk (fallback HTML served for a different route)!
  // We must clear the incorrect HTML and do a fresh client render.
  rootElement.innerHTML = '';
  const root = createRoot(rootElement);
  root.render(AppTree);
}